import Noty from "noty";
export class Notification {
    static RemoveNotyElements() {
        $(".noty_bar").remove();
    }
    static Notify(text, type, layout, container, timeout = 3000, onClose = null) {
        this.RemoveNotyElements();
        const noty = new Noty({
            text,
            theme: "relax",
            type,
            layout,
            timeout: timeout || false,
            closeWith: ["button"],
            container,
            force: container ? true : false
        });
        if (onClose) {
            noty.on("afterClose", function () {
                onClose();
            });
        }
        noty.show();
        return noty;
    }
    static NotifyUI(element, message, error, dismiss) {
        element.html(message);
        element.removeClass("alert alert--error");
        element.removeClass("alert alert--info");
        if (error) {
            element.addClass("alert alert--error");
        }
        else if (!error && message.length > 0) {
            element.addClass("alert alert--info");
        }
        if (dismiss) {
            window.setTimeout(() => {
                element.removeClass("alert alert--error");
                element.removeClass("alert alert--info");
                element.html("");
            }, 5000);
        }
    }
    static NotifyModal(text, buttons) {
        const noty = new Noty({
            text,
            layout: "center",
            closeWith: ["button"],
            buttons,
            modal: true
        });
        noty.show();
        return noty;
    }
}
//# sourceMappingURL=Notification.js.map